export default "__VITE_ASSET__KkTBfGQy__"